import template from './detail.html';
import {DetailController} from './detail.controller.js';

const DetailComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: DetailController,
    controllerAs: 'vm',
    bindings: {
        id: '<',
    }
};

export {DetailComponent};



// WEBPACK FOOTER //
// ./app/components/pacijent/detail/detail.js